module.exports = __webpack_public_path__ + "img/stabilizeImg.fab7fb6c.png";